import watchGetSettings from './getSettings';
import watchUpdateAppSettings from './updateSettings';

const watchAppSettings = [watchGetSettings, watchUpdateAppSettings];

export default watchAppSettings;
